import styled from "styled-components";
import { useGetModulesInfoQuery } from "../../../../data/generated";
import { Loader } from "../../../../design-system/atoms/Loader";
import { theme } from "../../../../theme";

export const ModulesInfo = () => {
  const { data, loading } = useGetModulesInfoQuery();

  if (loading || !data) {
    return <Loader />;
  }

  const {
    modulesInfo: { totalCount, offlineCount, potentiallyOfflineCount },
  } = data;

  return (
    <Container>
      <ValueContainer>
        <Count>{totalCount}</Count>
        <Label>modules</Label>
      </ValueContainer>
      <ValueContainer>
        <Count>{offlineCount}</Count>
        <Label>offline</Label>
      </ValueContainer>
      <ValueContainer>
        <Count>{potentiallyOfflineCount}</Count>
        <Label>
          potentially offline (online + seen more than 3 minutes ago)
        </Label>
      </ValueContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  height: 100%;
`;

const ValueContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Count = styled.span`
  font-size: 4vh;
  font-weight: 600;
  color: ${theme.textColor.default};
`;

const Label = styled.span`
  font-size: 2vh;
  color: ${theme.textColor.secondary};
`;
